import { paths } from "@src/consts";
import axios from 'axios';
import apiStore from "./index";
import { setLangMeta } from './utils';
import { getImageUrl } from "@src/utils/helpers";
import browserAgent from '@src/utils/browser';

import { getFormData } from './utils';


const logger = Logger.get("content/api");



export const contact = async (text,email,subscribername) => {
  const {query} = text;
  const message = query
  const params = { message, email, subscribername };
  console.log("PARAMS",params);
  const formData = getFormData(params);
  const { data: body } = await apiStore.axios.post(paths.contact, 
    formData,
  );
  if (body.error) throw body;
  return body 
};


export const downloadWorksteet = async (contentid) => {
  const params = { contentid };

  const { data: body } = await apiStore.axios.get(paths.downloadWorksheet, {
    params,
  });
  if (body.error) throw body;
  return body ? { ...body, contentid } : { contentid, success: false };
};

export const downloadMilestoneReport = async (contentid) => {
  const params = { contentid };

  const { data: body } = await apiStore.axios.get(paths.downloadMilestoneReport, {
    params,
  });
  if (body.error) throw body;
  return body ? { ...body, contentid } : { contentid, success: false };
};

export const downloadMilestoneReportpdf = async (data) => {
  const {profileid,levelid,fromdate} = data;
  console.log(fromdate);
  const params = {profileid,fromdate,levelid}
  const { data: body } = await apiStore.axios.get(paths.downloadMilestoneReportpdf, 
    {params},
  );
  if (body.error) throw body;
  return body ? { ...body} : {  success: false };
};

export const fetchfaq = async (url) => {
  const { data: body } = await axios.get(url);
  if (body.error) throw body;
  return body ;
};

const fetchContent = async (payload = {}) => {
  try {
    const { contentid, ...dataParams } = payload;
    const params = {
      streamcodec: browserAgent.isSafari ? 'MPEGTS-HLS' : 'DASH',
      contentbypreferredlang: "YES" ,
      ...dataParams,
    };

    let { data: content } = await apiStore.axios.get(
      `${paths.contents}/${contentid}`,
      { params }
    );

    content.imageUrl = getImageUrl(content.posters);
    content = setLangMeta( content );

    return content;
  } catch (error) {
    logger.log(error);
    return {};
  }
};

const fetchContents = async (payload = {}) => {
  try {
    const params = {
      streamcodec: browserAgent.isSafari ? 'MPEGTS-HLS' : 'DASH',
      contentbypreferredlang: "YES" ,
      ...payload,
    };

    let { data: body } = await apiStore.axios.get(paths.contents, { params });

    return body.map( ( content ) => {
      content.imageUrl = getImageUrl( content.posters );
      content = setLangMeta( content );
      return content;
    })
    // ( ( a, b ) => Number( b.weight ?? 0 ) > Numb.sorter( a.weight ?? 0 ) ? 1 : -1 );

  } catch (error) {
    logger.log(error);
    return [];
  }
};

const fetchContentCount = async (payload = {}) => {
  try {
    const params = { ...payload };

    let { data: response } = await apiStore.axios.get(paths.contentCount, {
      params,
    });

    if (response.error) throw response;

    return response.count;
  } catch (err) {
    logger.log(err);
    return 0;
  }
};

export { fetchContent, fetchContents, fetchContentCount };
